// extracted by mini-css-extract-plugin
export default {"spinner":"l0GeTHFdDR6Px7X7lrjQ"};